import axios from 'axios';
import AuthService from '../services/authService';
import LocalStorageService from '../services/localStorageService';
import { apiUrl } from './config';

const localStorageService = new LocalStorageService();
const authService = new AuthService();
const api = axios.create({
    baseURL: apiUrl,
});

api.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${localStorageService.getTokenPayload()!.access_token}`;

    return config;
});

api.interceptors.response.use(config => {
    return config;
}, async (error) => {
    const originalRequest = error.config!;
    if (error.response?.status == 401 && !originalRequest._isRetry) {
        originalRequest._isRetry = true;
        const newTokenPayload = await authService.refreshToken(localStorageService.getTokenPayload()!.refresh_token);
        localStorageService.setTokenPayload(newTokenPayload);
        return api.request(originalRequest);
    }

    throw error;
});

export default api;